import moment from 'moment';
moment.suppressDeprecationWarnings = true;

function isDayLightTime(cunnentDatetime) {
    var currentTime = moment(new Date()).format("hh:mm:ss A");
    return moment(cunnentDatetime + " " + currentTime).isDST();
}

const ConvertToCurrentTimeZone = (datetime, format, hours, defaultSite) => {
    if (defaultSite === null) return;
    if (!format) format = "MM/DD/YYYY hh:mm A";
    var TimeZoneOffset = parseInt(defaultSite.offset);
    var TimeZoneDST = parseInt(defaultSite.dst);

    if (TimeZoneDST !== 0) {
        if (isDayLightTime(moment(moment(datetime).utc()).add(TimeZoneOffset, 'hours').format("MM/DD/YYYY"))) {
            TimeZoneOffset = TimeZoneOffset + TimeZoneDST;
        }
    }
    if (hours) {
        TimeZoneOffset = TimeZoneOffset + hours;
    }

    return moment(moment(datetime).utc()).add(TimeZoneOffset, 'hours').format(format);
}

const ConvertTimeToUTC = (datetime, format) => {
    if (typeof datetime === 'undefined') return '';
    if (!moment(datetime).isValid()) return '';
    if (!format) format = 'MM/DD/YYYY HH:mm:ss';

    return moment(datetime).utc().format(format);
};

const ConvertTimeZoneOffset = (datetime, defaultSite) => {
    if (typeof datetime === 'undefined') return '';
    if (!moment(datetime).isValid()) return '';
    var TimeZoneOffset = parseInt(defaultSite.offset);
    var TimeZoneDST = parseInt(defaultSite.dst);

    if (TimeZoneDST !== 0) {
        if (isDayLightTime(moment(datetime).add(TimeZoneOffset, 'hours').format("MM/DD/YYYY"))) {
            TimeZoneOffset = TimeZoneOffset + TimeZoneDST;
        }
    }

    return moment(datetime).add(TimeZoneOffset, 'hours').format('MM/DD/YYYY hh:mm A');
};

const GetTimeZoneOffset = (defaultSite) => {
    var TimeZoneOffset = parseInt(defaultSite.offset);
    var TimeZoneDST = parseInt(defaultSite.dst);

    if (TimeZoneDST !== 0) {
        if (isDayLightTime(moment(moment(new Date()).utc()).add(TimeZoneOffset, 'hours').format("MM/DD/YYYY"))) {
            TimeZoneOffset = TimeZoneOffset + TimeZoneDST;
        }
    }

    return TimeZoneOffset;
};

export { ConvertTimeToUTC, ConvertToCurrentTimeZone, ConvertTimeZoneOffset, GetTimeZoneOffset }
